import {
    DeleteTwoTone,
    EditTwoTone,
    PlusOutlined,
    ProfileTwoTone,
    QuestionCircleOutlined,
} from "@ant-design/icons";
import {
    Button,
    Card,
    Checkbox,
    Col,
    Form,
    Input,
    Modal,
    notification,
    Popconfirm,
    Row,
    Select,
    Skeleton,
} from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import { getUserRole, weekDays } from "../../services/util";

const { Option } = Select;

const frequencyOfReport = [
    { key: 1, title: "Daily" },
    { key: 2, title: "Weekly" },
    { key: 3, title: "Monthly" },
    { key: 4, title: "Yearly" },
    { key: 5, title: "Shift-Based" },
];

const weeksOfMonth = [
    { key: "0", title: "First" },
    { key: "1", title: "Second" },
    { key: "2", title: "Third" },
    { key: "3", title: "Fourth" },
    { key: "4", title: "Last" },
];

const CheckboxGroup = Checkbox.Group;

const customFields = [
    { key: "checkin_count", title: "Check-Ins" },
    { key: "reservation_count", title: "Reservations" },
    { key: "walkin_count", title: "Walk-Ins" },
    { key: "cash_collected", title: "Cash Collected" },
    { key: "cash_dispence", title: "Cash Dispense" },
    { key: "review", title: "Reviews" },
    { key: "transaction_avg", title: "Average Transactions" },
    { key: "new_calls_count", title: "Kiosk Calls" },
    { key: "call_logs", title: "Call Logs" },
    { key: "hk_order_count", title: "HouseKeeping Orders" },
    { key: "hk_ticket_count", title: "HouseKeeping Tickets" },
    { key: "mnt_ticket_count", title: "Maintenance Tickets" },
    { key: "dinning_order_count	", title: "Dinning Orders" },
    { key: "walk_in_logs", title: "WalkIn Logs" },
    { key: "call_logs_count", title: "Call Logs Count" },
    { key: "self_checkin_count", title: "Self Check-In" },
    { key: "shift_notes_count", title: "Shift Notes" },
    { key: "missed_call_rate", title: "Missed Call Rate" },
];

const reportFormates = [
    { key: "1", title: "HTML" },
    { key: "2", title: "PDF" },
];

function ReportsTable() {
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [title, setTitle] = useState("ADD");
    const [searchKey, setSearchKey] = useState("");
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const userRole = getUserRole();
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [historyTableData, setHistoryTableData] = useState([]);
    const [historyFormData, setHistoryFormData] = useState({
        staff_id,
        limit: 5,
        page: 0,
    });
    const [tableVisible, setTableVisible] = useState(false);
    const [totalHistoryRecords, setTotalHistoryRecords] = useState(0);
    const [formData, setFormData] = useState({
        staff_id,
        page: 0,
        limit: 10,
        sorting: 1,
        sort_by: "created_at",
        search_by: searchKey,
    });

    const columns = [
        {
            title: "Name",
            dataIndex: "hotel_names",
            key: "hotel_names",
            width: "15%",
            render: (record) => (
                <>
                    {record.map((e) => (
                        <p key={e}>{e}</p>
                    ))}
                </>
            ),
        },
        {
            title: "Report For",
            render: (text, record) => {
                return (
                    <CheckboxGroup disabled={true} value={record.report_fields}>
                        <Row>
                            {customFields.map((e) => (
                                <Col span={16} key={e.key}>
                                    <Checkbox value={e.key}>{e.title}</Checkbox>
                                </Col>
                            ))}
                        </Row>
                    </CheckboxGroup>
                );
            },
            width: "15%",
        },
        {
            title: "Report Time",
            dataIndex: "report_time",
            key: "report_time",
            width: "10%",
        },
        {
            title: "Format",
            dataIndex: "report_format",
            key: "report_format",
            width: "10%",
            render: (text) =>
                text.map(
                    (f) => reportFormates.find(({ key }) => key == f)?.title,
                ),
        },
        {
            title: "Frequency",
            render: (text, record) => {
                const temp_frequency = frequencyOfReport.find(
                    (e) => e.key == record.frequency,
                );
                return (
                    <>
                        <span>{temp_frequency.title}</span>
                    </>
                );
            },
            width: "10%",
        },
        {
            title: "Send To",
            render: (text, record) => (
                <>
                    {record.email_ids.map((email, index) => (
                        <p key={index}>{email}</p>
                    ))}
                </>
            ),
            width: "15%",
        },
        {
            title: "Created By",
            render: (text, record) => (
                <span>
                    {`${record.staff_first_name} ${record.staff_last_name}`}
                </span>
            ),
            width: "10%",
        },
        {
            title: "Actions",
            render: (text, record) => (
                <>
                    <Popconfirm
                        onConfirm={() => deleteReportSettings(record.id)}
                        title="Are you sure want to delete?"
                        icon={
                            <QuestionCircleOutlined
                                style={{
                                    color: "red",
                                }}
                            />
                        }
                    >
                        <DeleteTwoTone className="actionIcon actionIconDelete" />
                    </Popconfirm>
                    <EditTwoTone
                        className="actionIcon actionIconDelete"
                        id={record.id}
                        details={JSON.stringify(record)}
                        onClick={editReportSettings}
                    />
                    <ProfileTwoTone
                        className="actionIcon"
                        id={record.id}
                        onClick={showHistory}
                    />
                </>
            ),
        },
    ];

    async function showHistory(e) {
        const newFormData = {
            ...historyFormData,
            report_id: e.currentTarget.getAttribute("id"),
        };
        setHistoryFormData(newFormData);
        const { success, data, message, total } = await HTTP(
            "/reports/getReportSettingsHistory",
            newFormData,
        );

        if (success) {
            setHistoryTableData(data);
            setTableVisible(true);
            setTotalHistoryRecords(total);
        } else {
            notification["error"]({
                message: message,
            });
        }
    }

    async function deleteReportSettings(id) {
        if (
            userRole !== "Super Admin" &&
            userRole !== "Admin" &&
            userRole !== "Customer Success"
        ) {
            return notification["error"]({
                message: "You are not allowed to perform this action",
            });
        } else {
            // const deleteId = e.currentTarget.getAttribute("id");
            const { success, message } = await HTTP(
                "/reports/deleteReportSetting",
                {
                    id,
                    staff_id,
                },
            );

            if (success) {
                notification["info"]({
                    message: "Action performed successfully.",
                });
            } else {
                notification["error"]({
                    message: message,
                });
            }
            getreports();
        }
    }

    function editReportSettings(e) {
        if (
            userRole !== "Super Admin" &&
            userRole !== "Admin" &&
            userRole !== "Customer Success"
        ) {
            return notification["error"]({
                message: "You are not allowed to perform this action",
            });
        }
        const editDetails = JSON.parse(e.currentTarget.getAttribute("details"));
        form.setFieldsValue({
            id: editDetails.id,
            hotel_id: editDetails.hotel_id,
            hotel_name: editDetails.hotel_name,
            report_fields: editDetails.report_fields,
            frequency: editDetails.frequency,
            week_day: editDetails?.recurring?.week_day,
            week_number: editDetails?.recurring?.week_number,
            report_time: editDetails.report_time,
            email_ids: editDetails.email_ids.join(),
            report_format: editDetails.report_format,
            shift_start_time: editDetails.shift_start_time,
            shift_end_time: editDetails.shift_end_time,
        });
        setTitle("Edit");
        setVisible(true);
    }

    const {
        status: hotelListStatus,
        data: hotelListRes,
        refetch: getHotelList,
    } = useQuery(
        "mapHotels",
        async () => {
            return await HTTP("/dashboard/getMapHotels", { staff_id });
        },
        { enabled: false },
    );

    const {
        status: reportStatus,
        data: reportRes,
        refetch: getreports,
    } = useQuery(
        "reports",
        async () => {
            return await HTTP("/reports/getReportSettings", {
                ...formData,
            });
        },
        { enabled: false },
    );

    useEffect(() => {
        getreports();
        getHotelList();
    }, []);

    useEffect(() => {
        getreports();
    }, [formData]);

    useEffect(() => {
        if (reportStatus === "success") {
            const { data: tableData, total } = reportRes;
            setTableData(tableData);
            setTotalRecords(total);
        }
    }, [reportStatus, reportRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const newFormData = { ...formData, ...others };
        setFormData(newFormData);
    }

    function closeModel() {
        setTitle("");
        form.resetFields();
        setVisible(false);
    }

    function openAddModal() {
        form.resetFields();
        setTitle("ADD");
        setVisible(true);
    }

    async function handleSubmit(formData) {
        formData.staff_id = staff_id;
        let url = "";
        if (!formData.id) {
            delete formData.id;
            url = "/reports/addReportSetting";
        } else {
            url = "/reports/editReportSetting";
        }
        const temp_frequency = frequencyOfReport.find(
            (e) => e.title == formData.frequency,
        );

        if (temp_frequency) {
            formData.frequency = temp_frequency.title;
        }
        formData.report_format = [formData.report_format];
        formData.recurring = {};
        if (!Array.isArray(formData.email_ids))
            formData.email_ids = formData.email_ids.includes(",")
                ? formData.email_ids.split(",")
                : [formData.email_ids];
        if (formData.frequency != 1) {
            formData.recurring = { week_day: formData.week_day };
            delete formData["week_day"];
            if (formData.frequency == 3) {
                formData.recurring["week_number"] = formData.week_number;
                delete formData["week_number"];
            }
        }
        const { success, data } = await HTTP(url, formData);
        if (success) {
            notification["info"]({
                message: "Action performed successfully.",
            });
        } else {
            notification["error"]({
                message: data.message,
            });
        }
        getreports();
        closeModel();
    }

    let historyColumns = columns.slice(0, -1);
    historyColumns.push({
        title: "Changed By",
        render: (text, record) => (
            <p>{`${record.changes_by_staff_first_name} ${record.changes_by_staff_last_name}`}</p>
        ),
    });

    function closeHistoryModel() {
        setTableVisible(false);
        setHistoryTableData([]);
    }

    async function handleHistoryTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const updatedFormData = { ...historyFormData, ...formData, ...others };
        setHistoryFormData(updatedFormData);
        const { success, data, message, total } = await HTTP(
            "/reports/getReportSettingsHistory",
            { ...updatedFormData },
        );
        if (success) {
            setHistoryTableData(data);
            setTotalHistoryRecords(total);
        } else {
            notification["error"]({
                message: message,
            });
        }
    }

    function handleSearchInputSubmit() {
        const updatedFormData = { ...formData, search_by: searchKey };
        setFormData(updatedFormData);
    }

    function handleSearchInputChange(event) {
        setSearchKey(event.target.value);
    }

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader
                    extraAfter={
                        (userRole === "Super Admin" ||
                            userRole === "Admin" ||
                            userRole === "Support" ||
                            userRole === "Customer" ||
                            userRole === "Operations" ||
                            userRole === "Customer Success") && (
                            <Button
                                type="primary"
                                style={{ marginRight: "5px" }}
                                onClick={openAddModal}
                            >
                                <PlusOutlined /> Add
                            </Button>
                        )
                    }
                />
                <Card
                    className="box-shadow margin-10"
                    title={
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Input
                                placeholder="Hotel Name"
                                style={{ width: "20%" }}
                                className="margin-right-10"
                                value={searchKey}
                                onChange={handleSearchInputChange}
                            />
                            <Button
                                type="primary"
                                onClick={handleSearchInputSubmit}
                            >
                                Search
                            </Button>
                        </div>
                    }
                >
                    {reportStatus === "loading" || reportStatus === "idle" ? (
                        <Skeleton
                            active
                            title={false}
                            paragraph={{ rows: 20, width: 40 }}
                        />
                    ) : (
                        <CustomTable
                            columns={columns}
                            tableData={tableData}
                            noOfrecords={totalRecords}
                            handleTableChange={handleTableChange}
                            rowKey="id"
                            className="report-table"
                            // isScroll
                        />
                    )}
                </Card>
            </Card>
            <Modal
                title={title}
                open={visible}
                footer=""
                onCancel={closeModel}
                destroyOnClose={true}
                className="test"
            >
                <Form
                    form={form}
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 16,
                    }}
                    onFinish={handleSubmit}
                    autoComplete="off"
                >
                    <Form.Item
                        label="Hotel Name"
                        name="hotel_id"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Hotel!",
                            },
                        ]}
                        valuePropName="defaultValue"
                    >
                        <Select
                            id="hotel_id"
                            showSearch
                            mode="multiple"
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                        >
                            {hotelListStatus === "success" &&
                            hotelListRes?.data.length > 0
                                ? hotelListRes.data.map((h) => (
                                      <Option
                                          key={h.hotel_id}
                                          value={h.hotel_id}
                                      >
                                          {`${h.hotel_id} - ${h.hotel_name} - ${h.city}`}
                                      </Option>
                                  ))
                                : ""}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Report Fields"
                        name="report_fields"
                        rules={[{ required: true }]}
                    >
                        <CheckboxGroup id="report_fields">
                            <Row>
                                {customFields.map((e) => (
                                    <Col span={16} key={e.key}>
                                        <Checkbox value={e.key}>
                                            {e.title}
                                        </Checkbox>
                                    </Col>
                                ))}
                            </Row>
                        </CheckboxGroup>
                    </Form.Item>
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: "Please Select Report Frequency!!",
                            },
                        ]}
                        label="Frequency"
                        name="frequency"
                        valuePropName="defaultValue"
                    >
                        <Select id="frequency">
                            {frequencyOfReport.map((e) => (
                                <Option key={e.key} value={e.key}>
                                    {e.title}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.frequency !== currentValues.frequency
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("frequency") &&
                            getFieldValue("frequency") != 1 &&
                            getFieldValue("frequency") != 3 &&
                            getFieldValue("frequency") != 4 &&
                            getFieldValue("frequency") != 5 && (
                                <Form.Item
                                    label="WeekDay"
                                    name="week_day"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Select Weekdays!!",
                                        },
                                    ]}
                                >
                                    <CheckboxGroup id="week_day">
                                        {weekDays.map((e) => (
                                            <Checkbox key={e.key} value={e.key}>
                                                {e.title}
                                            </Checkbox>
                                        ))}
                                    </CheckboxGroup>
                                </Form.Item>
                            )
                        }
                    </Form.Item>
                    <Form.Item
                        shouldUpdate={(prevValues, currentValues) =>
                            prevValues.frequency !== currentValues.frequency
                        }
                    >
                        {({ getFieldValue }) =>
                            getFieldValue("frequency") &&
                            getFieldValue("frequency") == 5 && (
                                <>
                                    <Form.Item
                                        label="Start"
                                        name="shift_start_time"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please Select Start time of shift!!",
                                            },
                                        ]}
                                    >
                                        <Select id="shift_start_time">
                                            {[...Array(24).keys()].map((e) => (
                                                <Option
                                                    key={e}
                                                    value={
                                                        e == 12
                                                            ? "12:00 PM"
                                                            : e > 12
                                                            ? `${e - 12}:00 PM`
                                                            : e > 9
                                                            ? `${e}:00 AM`
                                                            : `0${e}:00 AM`
                                                    }
                                                >
                                                    {e == 12
                                                        ? "12:00 PM"
                                                        : e > 12
                                                        ? `${e - 12}:00 PM`
                                                        : e > 9
                                                        ? `${e}:00 AM`
                                                        : `0${e}:00 AM`}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        label="End"
                                        name="shift_end_time"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please Select End time of shift!!",
                                            },
                                        ]}
                                    >
                                        <Select id="shift_end_time">
                                            {[...Array(24).keys()].map((e) => {
                                                console.log(
                                                    e,
                                                    e == 12
                                                        ? "12:00 PM"
                                                        : e > 12
                                                        ? `${e - 12}:00 PM`
                                                        : e > 9
                                                        ? `${e}:00 AM`
                                                        : `0${e}:00 AM`,
                                                );
                                                return (
                                                    <Option
                                                        key={e}
                                                        value={
                                                            e == 12
                                                                ? "12:00 PM"
                                                                : e > 12
                                                                ? `${
                                                                      e - 12
                                                                  }:00 PM`
                                                                : e > 9
                                                                ? `${e}:00 AM`
                                                                : `0${e}:00 AM`
                                                        }
                                                    >
                                                        {e == 12
                                                            ? "12:00 PM"
                                                            : e > 12
                                                            ? `${e - 12}:00 PM`
                                                            : e > 9
                                                            ? `${e}:00 AM`
                                                            : `0${e}:00 AM`}
                                                    </Option>
                                                );
                                            })}
                                        </Select>
                                    </Form.Item>
                                </>
                            )
                        }
                    </Form.Item>
                    <Form.Item label="Format" name="report_format">
                        <Select>
                            {reportFormates.map((f) => (
                                <Option key={f.key} value={parseInt(f.key)}>
                                    {f.title}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Report Time"
                        name="report_time"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Report Time!",
                            },
                        ]}
                    >
                        <Select id="report_time">
                            {[...Array(24).keys()].map((e) => (
                                <Option
                                    key={e > 9 ? `${e} : 00` : `0${e}:00`}
                                    value={e > 9 ? `${e} : 00` : `0${e}:00`}
                                >
                                    {e > 9 ? `${e} : 00` : `0${e}:00`}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Email"
                        name="email_ids"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter email id!!",
                            },
                        ]}
                    >
                        <Input type="email" id="email_ids" multiple />
                    </Form.Item>
                    <Form.Item name="id" className="hidden">
                        <Input id="id" disabled></Input>
                    </Form.Item>

                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                title="History"
                open={tableVisible}
                footer=""
                onCancel={closeHistoryModel}
                destroyOnClose={true}
                width={"70%"}
            >
                <CustomTable
                    columns={historyColumns}
                    tableData={historyTableData}
                    noOfrecords={totalHistoryRecords}
                    handleTableChange={handleHistoryTableChange}
                    rowKey="id"
                    className="kiosk-property-table"
                />
            </Modal>
        </>
    );
}

export { ReportsTable };
